import './subsection-title.css';

export default function decorate(block: HTMLElement): void {
	const firstElement = block.firstElementChild;
	if (!firstElement) return;

	const children = Array.from(firstElement.children);
	const headingContainer = children[0] as HTMLElement;
	headingContainer.classList.add('subsection-title__heading-container');
}

const subsectionContainers = document.querySelectorAll(
	'.subsection-title-container',
);

subsectionContainers.forEach((container) => {
	const titleDiv = container.querySelector('.subsection-title');

	if (titleDiv) {
		if (titleDiv.classList.contains('gray')) {
			container.classList.add('gray');
		} else if (titleDiv.classList.contains('blue')) {
			container.classList.add('blue');
		}
	}
});
